var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 695,
    viewBox: "0 0 640 695",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.664 356.89C20.549 356.421 24.4486 381.216 38.9699 403.825C49.2524 419.827 61.6793 428.631 86.5329 446.239C108.534 461.831 130.107 477.103 161.962 488.772C164.156 489.581 184.362 495.381 224.764 506.98C252.151 514.846 274.671 521.264 275.12 531.076C275.419 537.635 265.655 541.288 267.081 545.361C269.545 552.368 297.869 539.711 316.18 552.618C330.053 562.4 323.7 576.684 337.294 587.645C357.54 603.975 392.467 589.052 393.045 591.667C393.514 593.813 370.894 607.998 343.786 604.744C325.276 602.518 314.734 593.374 298.178 598.924C291.875 601.04 289.83 603.566 282.829 604.245C271.29 605.373 267.251 599.443 255.502 597.437C240.173 594.822 239.226 603.586 222.151 602.288C206.423 601.09 193.527 592.606 187.823 588.842C178.757 582.873 179.136 580.727 172.663 577.603C159.927 571.464 150.014 575.716 137.537 576.075C100.825 577.123 74.4951 543.534 70.2564 538.134C67.9525 535.189 54.7179 518.319 59.924 509.725C62.3176 505.782 67.0649 506.131 68.0124 502.997C69.9871 496.469 51.7458 487.245 39.7079 477.892C6.25718 451.889 -4.16503 405.432 2.66674 400.551C5.91807 398.235 12.0517 406.021 17.198 403.366C27.7797 397.916 16.2206 357.499 18.664 356.89Z",
    fill: "url(#paint0_linear_328_1311)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9469 98.4249C100.585 99.3732 87.6497 106.51 78.0454 119.108C71.2535 128.022 68.8798 136.676 64.1225 153.995C59.9138 169.327 55.7848 184.35 55.725 204.354C55.725 205.732 56.5627 218.1 58.2582 242.835C59.4051 259.595 60.3725 273.37 55.0268 275.596C51.4563 277.083 47.4769 272.392 45.5122 274.009C42.1312 276.784 54.8273 289.94 51.3566 302.687C48.7236 312.35 39.5481 311.691 36.207 321.424C31.2303 335.927 46.4996 352.298 45.1731 353.136C44.086 353.825 31.6791 344.133 28.0388 328.451C25.5555 317.74 28.4976 310.054 22.1047 301.999C19.6712 298.924 17.856 298.295 16.0807 294.552C13.1386 288.383 15.612 284.949 14.3653 278.032C12.7396 269.008 7.69312 270.246 4.99033 260.513C2.49698 251.549 4.60137 242.695 5.53887 238.782C7.0249 232.554 8.29151 232.334 8.7104 228.121C9.54816 219.826 5.20974 215.185 2.50695 208.337C-5.44184 188.193 7.86267 166.852 9.99697 163.418C11.1639 161.551 17.846 150.821 23.6406 151.988C26.3035 152.528 27.0614 155.223 28.9863 155.123C32.9956 154.903 34.4318 142.945 37.1944 134.39C44.8639 110.623 68.4909 95.5201 72.56 98.3251C74.4948 99.6627 71.4131 104.634 73.9164 106.95C79.0627 111.721 99.1192 97.1971 99.9469 98.4249Z",
    fill: "url(#paint1_linear_328_1311)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.15 627.193C331.958 632.604 306.556 642.855 281.343 646.958C232.224 654.963 192.66 638.203 193.039 635.868C193.388 633.732 227.317 643.544 242.327 626.564C246.406 621.953 246.297 618.509 251.253 615.474C260.22 609.974 270.542 615.085 286.689 619.327C315.682 626.944 330.542 623.101 331.15 627.193Z",
    fill: "url(#paint2_linear_328_1311)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.953 75.2965C96.3265 88.0236 88.8166 94.1825 83.3711 99.3432C63.3346 118.329 59.0061 135.298 55.4656 133.921C51.8851 132.533 54.4483 114.456 60.5121 99.6127C63.8332 91.4873 69.2887 78.1214 82.9921 68.8381C97.9622 58.6964 117.919 56.69 119.983 61.0521C120.672 62.5095 119.435 64.7355 108.953 75.2965Z",
    fill: "url(#paint3_linear_328_1311)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.764 32.833C270.133 36.9655 283.049 38.9719 304.302 42.256C339.249 47.6663 345.063 43.5737 359.764 50.631C374.734 57.818 370.535 62.9388 390.113 73.6695C407.267 83.0726 414.986 81.6052 424.651 91.4774C433.736 100.761 431.911 107.189 438.254 117.66C452.247 140.789 474.887 132.254 494.764 150.132C518.281 171.274 497.686 193.174 525.113 246.489C531.655 259.206 537.44 266.922 550.226 292.576C559.122 310.413 563.57 319.337 566.971 330.278C573.833 352.348 574.132 370.815 574.291 389.98C574.621 427.403 568.567 447.097 573.244 448.635C577.433 450.012 588.224 436.227 593.131 420.356C601.638 392.795 586.14 379.04 597.32 354.374C600.162 348.106 603.444 343.943 605.688 334.47C606.675 330.318 609.138 319.926 606.735 307.239C604.75 296.748 600.621 290.948 602.546 289.431C605.418 287.175 615.412 299.373 620.338 296.768C624.577 294.522 623.321 282.194 620.338 272.681C613.557 251.06 597.998 244.472 600.452 232.883C601.648 227.243 606.057 225.337 609.866 221.364C634.93 195.271 605.219 110.623 578.47 109.295C571.22 108.936 566.083 114.785 559.63 111.392C552.26 107.509 554.265 97.3968 544.98 89.4012C540.292 85.3585 535.754 84.4601 531.376 83.1125C515.269 78.1614 506.811 68.8881 493.706 59.0258C464.235 36.8557 423.374 20.8845 418.357 27.6024C415.515 31.4155 425.469 40.8885 422.546 44.3622C418.906 48.6845 401.682 36.2369 374.405 26.5543C361.16 21.8527 343.477 15.7437 322.084 16.0831C295.505 16.5024 269.225 26.7938 269.764 32.833Z",
    fill: "url(#paint4_linear_328_1311)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M596.263 482.164C594.019 503.356 579.747 524.848 571.15 523.011C565.465 521.803 563.221 510.593 562.782 505.203C560.797 481.116 585.232 457.828 593.131 461.212C598.258 463.418 596.811 477.014 596.263 482.164Z",
    fill: "url(#paint5_linear_328_1311)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M636.555 343.384C641.96 366.592 639.636 385.748 638.649 392.615C633.692 427.163 618.084 462.051 612.489 460.693C607.522 459.495 610.235 429.729 612.489 414.606C614.663 399.992 616.508 398.475 619.809 382.134C627.12 346.079 624.387 322.811 628.177 322.432C631.598 322.102 635.946 340.759 636.555 343.384Z",
    fill: "url(#paint6_linear_328_1311)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M603.064 529.829C606.046 532.254 596.043 556.64 574.809 573.819C553.077 591.398 528.732 594.023 509.922 595.81C467.655 599.833 424.999 589.91 425.159 583.242C425.328 576.375 470.907 571.154 493.177 569.627C526.768 567.321 531.305 571.773 548.639 566.483C583.696 555.792 599.683 527.074 603.064 529.829Z",
    fill: "url(#paint7_linear_328_1311)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.38 51.6391C144.797 48.7842 158.391 26.2049 181.988 12.4596C206.133 -1.60509 230.598 -0.507062 249.458 0.590962C291.844 3.04654 332.506 19.3372 331.329 25.9054C330.122 32.6632 284.275 30.8964 262.034 29.0198C228.484 26.1949 224.674 21.104 206.742 23.6894C170.458 28.91 150.302 54.8633 147.38 51.6391Z",
    fill: "url(#paint8_linear_328_1311)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M149.026 537.575C160.785 548.305 179.096 550.072 181.14 546.049C182.547 543.284 176.373 537.615 167.806 529.759C161.483 523.959 142.503 506.55 137.866 510.204C134.325 512.989 138.863 528.301 149.026 537.575Z",
    fill: "url(#paint9_linear_328_1311)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M629.025 250.471C632.765 250.561 636.007 269.936 636.007 285.408C635.997 314.815 624.268 342.106 620.049 341.308C617.147 340.759 617.596 326.904 618.055 312.36C618.902 285.608 623.959 250.351 629.025 250.471Z",
    fill: "url(#paint10_linear_328_1311)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6484 197.566C23.7302 184.6 25.2761 178.111 26.6325 174.608C34.8904 153.256 51.8851 145.879 49.5712 141.667C47.7661 138.383 35.5187 139.451 26.6325 145.66C13.6371 154.734 11.9317 171.923 10.675 184.59C8.85988 202.867 12.2508 220.505 14.6644 220.525C15.9909 220.535 16.4496 215.235 20.6484 197.566Z",
    fill: "url(#paint11_linear_328_1311)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M632.017 190.579C630.77 177.692 618.294 168.738 615.062 170.615C609.996 173.55 620.657 206.999 627.03 206.55C630.242 206.331 632.685 197.447 632.017 190.579Z",
    fill: "url(#paint12_linear_328_1311)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.891 364.396C17.766 351.589 7.81258 339.9 4.22216 340.938C-1.39285 342.565 0.920974 377.602 7.21418 378.7C10.3857 379.249 14.8837 371.224 15.891 364.396Z",
    fill: "url(#paint13_linear_328_1311)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M520.196 526.784C515.937 529.349 518.64 536.536 516.037 544.133C510.801 559.405 487.174 567.551 482.746 562.869C479.345 559.276 486.805 547.557 485.519 546.908C484.122 546.199 478.866 561.671 465.402 570.505C459.169 574.598 455.349 574.528 434.884 578.142C401.244 584.081 402.52 585.858 395.349 585.079C370.954 582.434 353.81 561.472 355.127 559.395C356.244 557.638 369.787 570.565 389.804 569.108C393.365 568.848 396.955 568.15 421.011 556.61C446.712 544.292 450.133 541.488 460.545 539.262C476.642 535.818 477.45 540.609 486.207 537.175C515 525.896 518.411 469.397 518.8 462.909C519.997 443.055 516.745 430.707 518.8 430.288C522.001 429.629 530.319 459.445 534.747 484.43C541.649 523.34 535.017 527.443 533.361 528.162C529.212 529.968 524.405 524.249 520.196 526.784Z",
    fill: "url(#paint14_linear_328_1311)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M612.799 473.839H79.7017C67.7236 473.839 58.0195 464.117 58.0195 452.138V114.985C58.0195 102.997 67.7336 93.2842 79.7017 93.2842H612.789C624.767 93.2842 634.471 103.007 634.471 114.985V452.138C634.481 464.127 624.767 473.839 612.799 473.839Z",
    fill: "#252450"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M617.028 473.52H614.445C604.81 473.52 596.991 465.704 596.991 456.051V110.423C596.991 100.781 604.81 92.9547 614.445 92.9547H617.028C626.662 92.9547 634.481 100.781 634.481 110.423V456.051C634.481 465.694 626.662 473.52 617.028 473.52Z",
    fill: "#2C416C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M620.189 177.632H618.793C613.557 177.632 609.318 173.39 609.318 168.149V145.899C609.318 140.659 613.557 136.417 618.793 136.417H620.189C625.425 136.417 629.664 140.659 629.664 145.899V168.149C629.664 173.39 625.415 177.632 620.189 177.632Z",
    fill: "#286981"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M623.4 177.632H622.004C616.768 177.632 612.529 173.39 612.529 168.149V145.899C612.529 140.659 616.768 136.417 622.004 136.417H623.4C628.636 136.417 632.875 140.659 632.875 145.899V168.149C632.875 173.39 628.636 177.632 623.4 177.632Z",
    fill: "#29A6B8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M620.189 218.199H618.793C613.557 218.199 609.318 213.957 609.318 208.716V202.567C609.318 197.327 613.557 193.084 618.793 193.084H620.189C625.425 193.084 629.664 197.327 629.664 202.567V208.716C629.664 213.957 625.415 218.199 620.189 218.199Z",
    fill: "#286981"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M623.4 218.199H622.004C616.768 218.199 612.529 213.957 612.529 208.716V202.567C612.529 197.327 616.768 193.084 622.004 193.084H623.4C628.636 193.084 632.875 197.327 632.875 202.567V208.716C632.875 213.957 628.636 218.199 623.4 218.199Z",
    fill: "#29A6B8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M562.814 461.601H89.0876C78.5856 461.601 70.0684 453.077 70.0684 442.566V121.334C70.0684 110.823 78.5856 102.298 89.0876 102.298H562.814C573.315 102.298 581.833 110.823 581.833 121.334V442.566C581.843 453.087 573.325 461.601 562.814 461.601Z",
    fill: "#AFE3EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.004 436.746L70.1874 436.097L345.094 289.671L580.944 220.675V126.165L267.99 236.866L69.1602 325.356V448.984C69.1602 455.772 84.3895 461.262 103.169 461.262H546.915C547.913 461.262 548.9 461.242 549.877 461.212L570.193 457.918C576.786 455.682 580.925 452.508 580.925 448.984V341.667L450.004 436.746Z",
    fill: "#E0F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.736 101.969L69.1699 154.125V221.134L420.812 101.969H231.736Z",
    fill: "#E0F3F9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.301 185.887V381.186C548.301 390.11 541.449 397.347 533.002 397.347H272.626C264.179 397.347 257.327 390.11 257.327 381.186V185.887C257.327 176.963 264.179 169.726 272.626 169.726H533.011C541.459 169.726 548.301 176.963 548.301 185.887Z",
    fill: "#87CCD8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.301 144.452C548.301 155.652 539.235 164.726 528.045 164.726H277.593C266.403 164.726 257.337 155.652 257.337 144.452C257.337 133.781 264.189 125.127 272.636 125.127H533.021C541.459 125.127 548.301 133.781 548.301 144.452Z",
    fill: "#29A6B8"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M439.448 233.831C439.448 245.74 434.143 256.44 425.785 263.687C418.883 269.657 409.877 273.28 400.054 273.28C390.24 273.28 381.264 269.667 374.352 263.717C365.964 256.48 360.639 245.77 360.639 233.841C360.639 212.09 378.321 194.402 400.044 194.402C421.766 194.392 439.448 212.08 439.448 233.831Z",
    fill: "#AFE3EF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M413.529 261.322H387.588C384.087 261.322 381.334 258.327 381.634 254.833C381.703 253.965 381.783 253.086 381.853 252.218C382.801 241.108 390.889 232.633 400.553 232.633C405.35 232.633 409.769 234.729 413.11 238.203C416.451 241.677 418.715 246.538 419.233 252.048C419.323 252.967 419.403 253.885 419.483 254.793C419.802 258.297 417.049 261.322 413.529 261.322Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M412.028 220.558C413.516 214.282 409.639 207.987 403.368 206.498C397.098 205.009 390.808 208.889 389.32 215.165C387.832 221.441 391.709 227.736 397.98 229.225C404.25 230.715 410.54 226.834 412.028 220.558Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M439.42 382.374H357.439C351.325 382.374 346.318 377.363 346.318 371.244C346.318 365.125 351.325 360.114 357.439 360.114H439.42C445.534 360.114 450.54 365.125 450.54 371.244C450.54 377.363 445.534 382.374 439.42 382.374Z",
    fill: "#FED601"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M377.128 374.767V361.651H378.883V374.897C378.883 375.436 379.113 375.646 379.372 375.646C379.472 375.646 379.561 375.646 379.751 375.606L379.99 376.944C379.741 377.033 379.442 377.103 378.983 377.103C377.666 377.113 377.128 376.275 377.128 374.767Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M381.795 371.683C381.795 368.219 384.059 366.223 386.602 366.223C389.145 366.223 391.409 368.219 391.409 371.683C391.409 375.117 389.145 377.113 386.602 377.113C384.059 377.113 381.795 375.117 381.795 371.683ZM389.584 371.683C389.584 369.307 388.377 367.69 386.592 367.69C384.807 367.69 383.6 369.307 383.6 371.683C383.6 374.059 384.807 375.656 386.592 375.656C388.377 375.656 389.584 374.059 389.584 371.683Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M393.335 378.85C393.335 377.962 393.903 377.123 394.851 376.504V376.415C394.322 376.085 393.923 375.526 393.923 374.718C393.923 373.859 394.532 373.17 395.06 372.791V372.701C394.372 372.162 393.714 371.154 393.714 369.916C393.714 367.65 395.499 366.223 397.604 366.223C398.172 366.223 398.691 366.333 399.07 366.482H402.69V367.83H400.566C401.054 368.299 401.413 369.078 401.413 369.966C401.413 372.192 399.738 373.56 397.614 373.56C397.115 373.56 396.536 373.44 396.068 373.21C395.689 373.52 395.409 373.869 395.409 374.438C395.409 375.097 395.838 375.566 397.225 375.566H399.239C401.653 375.566 402.86 376.325 402.86 378.042C402.86 379.968 400.825 381.625 397.624 381.625C395.09 381.625 393.335 380.637 393.335 378.85ZM401.144 378.301C401.144 377.343 400.416 377.013 399.06 377.013H397.274C396.875 377.013 396.387 376.974 395.928 376.854C395.19 377.383 394.871 378.002 394.871 378.591C394.871 379.709 395.998 380.407 397.873 380.407C399.848 380.417 401.144 379.389 401.144 378.301ZM399.818 369.916C399.818 368.409 398.84 367.491 397.614 367.491C396.397 367.491 395.409 368.389 395.409 369.916C395.409 371.424 396.417 372.382 397.614 372.382C398.81 372.382 399.818 371.434 399.818 369.916Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M404.545 363.218C404.545 362.529 405.073 362.08 405.752 362.08C406.43 362.08 406.958 362.529 406.958 363.218C406.958 363.877 406.43 364.356 405.752 364.356C405.073 364.346 404.545 363.877 404.545 363.218ZM404.864 366.482H406.619V376.854H404.864V366.482Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M410.11 366.482H411.556L411.706 367.98H411.766C412.753 367.011 413.82 366.223 415.247 366.223C417.431 366.223 418.408 367.63 418.408 370.276V376.844H416.653V370.495C416.653 368.559 416.064 367.74 414.698 367.74C413.641 367.74 412.903 368.279 411.866 369.337V376.854H410.11V366.482Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M421.41 375.786C421.41 374.977 421.979 374.428 422.677 374.428C423.375 374.428 423.943 374.977 423.943 375.786C423.943 376.564 423.375 377.113 422.677 377.113C421.979 377.113 421.41 376.564 421.41 375.786Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M426.715 375.786C426.715 374.977 427.283 374.428 427.981 374.428C428.68 374.428 429.248 374.977 429.248 375.786C429.248 376.564 428.68 377.113 427.981 377.113C427.293 377.113 426.715 376.564 426.715 375.786Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M432.031 375.786C432.031 374.977 432.6 374.428 433.298 374.428C433.996 374.428 434.564 374.977 434.564 375.786C434.564 376.564 433.996 377.113 433.298 377.113C432.6 377.113 432.031 376.564 432.031 375.786Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M492.849 144.552C491.931 142.935 491.692 141.048 492.191 139.261C492.689 137.465 493.846 135.967 495.462 135.049C497.078 134.131 498.962 133.891 500.748 134.39C502.543 134.889 504.039 136.047 504.957 137.664C505.874 139.281 506.113 141.168 505.615 142.955C505.116 144.751 503.959 146.249 502.344 147.167C501.256 147.786 500.08 148.075 498.913 148.075C496.489 148.085 494.125 146.818 492.849 144.552ZM496.898 137.574C495.951 138.113 495.272 138.982 494.983 140.03C494.694 141.078 494.834 142.176 495.362 143.114C496.11 144.432 497.486 145.171 498.903 145.171C499.581 145.171 500.269 145.001 500.897 144.642C501.845 144.103 502.523 143.234 502.812 142.186C503.101 141.138 502.962 140.04 502.433 139.102C501.895 138.153 501.027 137.475 499.98 137.185C499.621 137.085 499.252 137.035 498.893 137.035C498.205 137.045 497.516 137.225 496.898 137.574Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M506.203 155.233L507.28 154.624C507.918 154.264 508.237 153.645 507.988 153.256C506.282 150.681 504.577 148.095 502.872 145.52C502.632 145.161 501.974 145.141 501.376 145.49C500.777 145.829 500.448 146.408 500.638 146.798C501.984 149.583 503.33 152.358 504.687 155.143C504.876 155.552 505.564 155.602 506.203 155.233Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M296.134 153.446H454.002C459.488 153.446 463.976 148.954 463.976 143.464C463.976 137.974 459.488 133.482 454.002 133.482H296.134C290.648 133.482 286.16 137.974 286.16 143.464C286.16 148.944 290.648 153.446 296.134 153.446Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M459.947 340.15H337.274C323.501 340.15 312.341 328.98 312.341 315.195C312.341 301.41 323.501 290.24 337.274 290.24H459.947C473.72 290.24 484.88 301.41 484.88 315.195C484.88 328.98 473.72 340.15 459.947 340.15Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M335.27 315.844C335.27 314.067 336.466 312.829 338.142 312.829C339.817 312.829 340.964 314.077 340.964 315.844C340.964 317.57 339.867 318.858 338.092 318.858C336.426 318.858 335.27 317.57 335.27 315.844Z",
    fill: "#2C416C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M355.336 315.844C355.336 314.067 356.533 312.829 358.208 312.829C359.884 312.829 361.031 314.077 361.031 315.844C361.031 317.57 359.934 318.858 358.158 318.858C356.483 318.858 355.336 317.57 355.336 315.844Z",
    fill: "#2C416C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M375.393 315.844C375.393 314.067 376.589 312.829 378.265 312.829C379.94 312.829 381.087 314.077 381.087 315.844C381.087 317.57 379.99 318.858 378.215 318.858C376.54 318.858 375.393 317.57 375.393 315.844Z",
    fill: "#2C416C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M395.448 315.844C395.448 314.067 396.645 312.829 398.321 312.829C399.996 312.829 401.143 314.077 401.143 315.844C401.143 317.57 400.046 318.858 398.271 318.858C396.595 318.858 395.448 317.57 395.448 315.844Z",
    fill: "#2C416C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M415.506 315.844C415.506 314.067 416.703 312.829 418.378 312.829C420.054 312.829 421.201 314.077 421.201 315.844C421.201 317.57 420.104 318.858 418.328 318.858C416.653 318.858 415.506 317.57 415.506 315.844Z",
    fill: "#2C416C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M435.562 315.844C435.562 314.067 436.758 312.829 438.434 312.829C440.109 312.829 441.256 314.077 441.256 315.844C441.256 317.57 440.159 318.858 438.384 318.858C436.708 318.858 435.562 317.57 435.562 315.844Z",
    fill: "#2C416C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M455.618 315.844C455.618 314.067 456.815 312.829 458.491 312.829C460.166 312.829 461.313 314.077 461.313 315.844C461.313 317.57 460.216 318.858 458.441 318.858C456.765 318.858 455.618 317.57 455.618 315.844Z",
    fill: "#2C416C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M301.559 279.759C301.559 279.759 301.11 281.056 300.302 283.322C296.801 293.045 286.539 320.655 275.728 340.988C269.574 352.588 263.241 361.831 257.875 364.037C245.708 369.048 217.104 333.452 200.817 308.886C194.405 299.224 189.907 291.268 189.059 288.173C186.067 277.193 185.907 254.654 185.907 254.654C185.907 254.654 209.006 251.24 219.976 269.208C230.947 287.175 248.899 314.127 248.899 314.127L250.186 312.46L301.559 279.759Z",
    fill: "#F0C45D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M275.727 340.988C269.574 352.587 263.241 361.831 257.875 364.037C245.708 369.048 217.104 333.452 200.817 308.886C200.369 277.073 203.779 269.856 207.011 269.208C213.494 267.9 231.755 290.529 232.942 315.125C233.38 324.308 231.715 339.192 240.92 346.069C241.12 346.219 242.057 346.908 243.364 347.557C254.963 353.356 271.12 343.883 275.727 340.988Z",
    fill: "#E29F37"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M301.559 279.759C301.559 279.759 301.11 281.056 300.302 283.322C295.216 281.136 290.758 279.18 288.793 278.191C282.809 275.197 270.841 320.116 264.857 321.114C258.873 322.112 270.841 295.161 263.091 300.411C255.352 305.652 248.899 328.102 248.899 328.102C248.211 323.999 248.939 318.249 250.186 312.46L301.559 279.759Z",
    fill: "#E29F37"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M179.724 245.67C179.724 245.67 182.088 240.579 175.007 239.571C167.916 238.553 144.209 234.141 143.411 240.399C142.613 246.658 179.385 254.813 179.724 245.67Z",
    fill: "#E29F37"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M247.923 298.355C249.229 297.227 251.254 295.67 253.997 294.302C258.275 292.176 258.973 293.164 262.095 291.258C265.855 288.972 266.962 286.257 270.193 286.187C270.752 286.177 271.66 286.167 272.068 286.736C272.836 287.814 271.251 290.21 269.176 293.284C267.88 295.211 267.231 296.179 266.134 297.337C264.419 299.164 262.095 301.649 259.043 302.408C253.598 303.755 248.521 298.934 247.923 298.355Z",
    fill: "url(#paint15_linear_328_1311)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0593 362.21C100.914 363.578 102.879 364.047 104.126 364.237C116.134 367.78 133.248 371.264 153.743 370.316C164.565 369.816 174.109 368.199 182.098 366.263C182.507 364.606 182.896 362.949 183.304 361.292C183.853 359.026 184.402 356.76 184.94 354.494C186.386 348.535 187.822 342.585 189.279 336.626C189.578 335.358 189.897 334.081 190.196 332.813C191.822 331.585 193.717 329.988 195.592 327.982C198.105 325.307 200.578 321.883 202.344 317.61C204.119 313.328 204.747 309.265 204.438 302.518C204.318 299.812 204.049 296.668 203.65 292.905C203.56 292.056 203.461 291.158 203.361 290.24C203.162 288.433 202.922 286.536 202.673 284.53C201.685 276.664 200.279 267.311 198.294 256.79C194.455 255.303 190.406 253.935 186.147 252.737C184.711 252.328 183.275 251.959 181.838 251.619C166.948 248.006 152.676 247.327 139.721 248.295C126.606 249.243 114.837 251.859 105.123 254.764C104.724 267.381 103.817 278.551 102.739 288.044C102.63 289.022 102.52 290 102.4 290.948C101.642 297.287 100.825 302.817 100.047 307.459C99.4383 311.112 98.8 314.666 98.1717 318.11C97.7328 320.505 97.304 322.841 96.8851 325.127C95.8379 330.887 94.9303 336.227 94.4317 340.998C93.3944 351.03 94.1125 358.557 99.0593 362.21Z",
    fill: "#F0C45D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M245.439 411.531C244.661 429.319 243.893 447.117 243.125 464.905C235.396 466.063 227.667 467.221 219.937 468.389C219.548 448.665 219.169 428.94 218.78 409.216C227.667 409.984 236.553 410.763 245.439 411.531Z",
    fill: "url(#paint16_linear_328_1311)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M245.798 454.594C243.065 453.666 239.944 453.206 234.738 453.017C229.422 452.817 223.388 454.005 220.605 454.744C219.468 461.092 219.758 466.672 218.112 472.182C214.901 482.993 212.457 487.085 210.682 495.75C209.415 501.899 208.976 507.918 209.176 513.767C214.96 515.544 224.455 517.74 236.204 517.241C245.689 516.832 253.298 514.816 258.405 513.049C257.138 493.873 248.69 477.533 246.855 467.77C244.671 456.151 246.496 455.273 245.798 454.594Z",
    fill: "#286881"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M215.14 511.192C215.389 511.252 215.629 511.212 215.848 511.082C217.593 510.064 225.283 505.991 232.095 509.036C233.122 509.495 234.419 510.244 235.705 511.521C235.875 511.681 236.084 511.791 236.313 511.821C240.871 512.28 246.855 512.18 252.54 509.545C254.196 508.776 256.38 507.878 257.956 507.05C258.574 506.72 259.023 507.239 259.422 507.818C260.29 509.086 260.27 514.776 260.459 516.572C260.509 517.071 260.23 517.541 259.771 517.7C254.495 519.467 246.636 524.788 237.6 525.177C226.33 525.656 214.242 523.829 208.278 522.222C207.829 522.102 207.53 521.683 207.54 521.204C207.57 519.627 207.63 512.739 207.73 510.972C207.76 510.334 208.338 509.884 208.947 510.004C210.891 510.413 213.385 510.793 215.14 511.192Z",
    fill: "#2C416C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9053 325.137C101.323 332.204 108.963 342.386 121.33 351.05C122.507 351.879 127.065 355.023 131.453 357.129C151.48 366.732 175.685 358.257 184.93 354.484C186.686 347.257 188.431 340.03 190.186 332.803C191.812 331.575 193.707 329.978 195.582 327.972L193.158 322.452L102.74 288.054C101.902 295.61 100.935 302.128 100.057 307.469C99.0496 313.658 97.9226 319.587 96.9053 325.137Z",
    fill: "#E29F37"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8701 426.055C88.418 430.877 93.4346 435.049 98.7604 438.483C115.685 449.453 135.762 453.216 154.242 448.026C174.578 442.316 186.157 427.672 190.206 422.003C190.156 421.753 190.097 421.503 190.047 421.254C186.736 406.371 183.434 391.487 180.133 376.604C179.595 374.189 179.056 371.773 178.528 369.357C178.458 369.048 178.388 368.738 178.318 368.429C178.238 368.04 178.149 367.66 178.069 367.271C153.434 366.253 128.78 365.245 104.146 364.227C104.016 364.676 103.887 365.105 103.747 365.554C102.959 368.209 102.161 370.885 101.333 373.57C100.436 376.514 99.5084 379.489 98.5709 382.474C96.4765 389.162 94.2723 395.91 91.9884 402.747C89.3156 410.673 86.6128 418.449 83.8701 426.055Z",
    fill: "#262956"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M136.529 379.439C136.529 379.439 148.677 378.421 149.694 385.518C150.711 392.615 148.677 403.765 151.719 403.765C154.761 403.765 152.736 372.342 152.736 372.342L136.529 379.439Z",
    fill: "url(#paint17_linear_328_1311)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M162.85 376.395L159.808 400.721C159.808 400.721 153.734 400.721 151.709 396.918C149.685 393.115 151.709 376.395 151.709 376.395H162.85Z",
    fill: "url(#paint18_linear_328_1311)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8701 426.055C88.418 430.877 93.4346 435.049 98.7604 438.483L190.047 421.254C186.736 406.371 183.434 391.487 180.133 376.604C179.595 374.189 179.056 371.773 178.527 369.357L174.807 368.289C151.38 397.517 141.865 400.142 137.547 398.684C137.208 398.575 133.946 397.257 127.424 394.632C124.053 393.274 120.672 391.937 117.301 390.579C108.524 387.045 106.4 386.117 106.161 386.526C105.562 387.555 118.069 395.261 117.301 396.658C116.872 397.447 112.544 395.76 112.234 395.64C106.121 393.244 102.67 388.663 101.094 386.516C99.8574 384.839 99.0296 383.362 98.5609 382.464C96.4665 389.132 94.2723 395.89 91.9785 402.737C89.3156 410.673 86.6128 418.449 83.8701 426.055Z",
    fill: "url(#paint19_linear_328_1311)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M101.313 373.58C110.818 376.185 122.706 378.591 136.52 379.439C153.933 380.517 168.843 378.79 180.113 376.614C179.076 371.903 178.637 369.956 178.507 369.367C178.438 369.058 178.368 368.748 178.298 368.439C178.218 368.05 178.129 367.67 178.049 367.281C153.414 366.263 128.76 365.255 104.126 364.237C103.996 364.686 103.867 365.115 103.727 365.564C102.939 368.219 102.131 370.895 101.313 373.58Z",
    fill: "#17163E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0593 362.21C100.914 363.578 102.879 364.047 104.126 364.237C116.134 367.78 133.248 371.264 153.743 370.316C164.565 369.816 174.109 368.199 182.098 366.263C182.507 364.606 182.896 362.949 183.304 361.292C168.085 363.697 142.144 366.522 126.406 361.192C122.826 359.974 118.148 358.397 114.259 354.095C109.651 349.014 107.497 341.677 106.47 342.026C106.21 342.116 106.17 342.665 106.16 342.945C105.921 348.814 111.347 357.029 110.21 358.147C109.591 358.756 106.809 357.399 104.136 355.103C97.3339 349.263 96.4163 341.877 94.4715 341.008C93.3944 351.03 94.1125 358.557 99.0593 362.21Z",
    fill: "#E29F37"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M145.635 426.055C148.876 430.737 156.945 441.358 169.81 448.225C174.518 450.761 179.883 452.777 185.887 453.805C190.335 454.564 194.504 454.684 198.294 454.434C200.448 443.843 202.613 433.242 204.767 422.651C206.313 414.995 207.879 407.359 209.435 399.703C209.454 399.962 209.464 400.232 209.484 400.491C210.402 415.355 209.863 430.966 207.41 447.337C213.633 448.355 220.774 449.144 228.673 449.363C237.37 449.613 245.199 449.144 251.961 448.345C253.268 435.309 254.444 417.61 253.986 396.658C253.317 366.073 252.569 341.108 244.012 327.393C241.589 323.53 238.567 320.565 234.747 318.619C225.881 314.097 216.196 316.832 213.484 317.6C200.698 321.214 191.971 332.923 180.392 354.774C176.343 362.41 171.945 371.264 166.908 381.446C164.095 387.135 161.453 392.556 158.969 397.686C157.892 399.892 154.9 406.161 151.03 414.426C148.866 419.038 147.051 422.991 145.635 426.055Z",
    fill: "#262956"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M147.111 422.871L169.811 448.225L204.768 422.651C206.313 414.995 207.879 407.359 209.435 399.703C209.455 399.962 209.465 400.232 209.485 400.491C210.313 382.424 210.961 358.647 208.418 361.182C204.069 365.534 206.872 393.923 200.319 396.658C198.773 397.307 197.118 396.329 194.246 394.632C183.734 388.423 181.48 375.965 180.063 376.385C179.046 376.694 179.285 383.482 182.088 389.561C184.861 395.58 189.917 400.451 190.186 400.711C192.311 402.727 193.378 403.266 193.228 403.755C192.919 404.774 186.157 404.215 158.96 397.696C154.402 407.199 150.432 415.674 147.111 422.871Z",
    fill: "url(#paint20_linear_328_1311)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M180.393 354.784C195.941 351.689 231.556 343.115 244.023 327.393C241.599 323.53 238.577 320.565 234.757 318.619C225.891 314.097 216.207 316.832 213.494 317.6C200.698 321.224 191.982 332.933 180.393 354.784Z",
    fill: "url(#paint21_linear_328_1311)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M120.842 265.923C133.757 282.474 146.663 299.034 159.579 315.584C187.334 309.844 215.1 304.095 242.856 298.355V317.61C242.856 317.61 169.263 347.008 150.862 348.016C132.461 349.034 101.474 288.213 101.474 288.213C107.936 280.787 114.389 273.35 120.842 265.923Z",
    fill: "url(#paint22_linear_328_1311)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M347.018 275.906C339.139 292.855 331.24 309.795 323.361 326.744C323.292 326.884 323.182 327.004 323.032 327.073C322.963 327.113 322.863 327.133 322.773 327.143L244.372 331.296C243.854 331.326 243.485 330.787 243.714 330.308C251.593 313.358 259.492 296.419 267.371 279.469C267.481 279.24 267.71 279.08 267.959 279.07L346.36 274.917C346.879 274.897 347.248 275.426 347.018 275.906Z",
    fill: "#683B76"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M245.868 330.198C253.747 313.248 261.646 296.309 269.525 279.359C269.635 279.13 269.864 278.97 270.114 278.96L267.95 279.07C267.69 279.08 267.471 279.239 267.361 279.469C259.482 296.419 251.583 313.358 243.704 330.308C243.485 330.777 243.844 331.316 244.372 331.296L246.537 331.186C246.018 331.216 245.649 330.677 245.868 330.198Z",
    fill: "#442762"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M238.806 299.363C247.243 297.676 255.681 295.989 264.118 294.292C265.066 296.818 265.973 299.932 266.522 303.546C267.519 310.144 266.911 315.754 266.143 319.637C257.735 319.218 249.328 318.798 240.92 318.369C240.222 312.04 239.514 305.702 238.806 299.363Z",
    fill: "url(#paint23_linear_328_1311)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M264.259 294.053C264.259 294.053 294.637 295.301 294.568 297.846C294.498 300.391 292.473 301.4 290.449 301.4C288.424 301.4 275.259 301.4 275.259 301.4C275.259 301.4 294.498 301.4 295.515 305.452C296.532 309.505 293.491 310.523 293.491 310.523C293.491 310.523 292.473 315.594 288.424 315.594C284.375 315.594 272.477 316.492 272.477 316.492C272.477 316.492 289.441 316.612 287.417 319.647C285.392 322.691 264.129 319.647 264.129 319.647L264.259 294.053Z",
    fill: "url(#paint24_linear_328_1311)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M204.299 303.186C204.299 303.186 204.349 302.947 204.438 302.518C204.319 299.812 204.049 296.668 203.65 292.905C203.561 292.056 203.461 291.158 203.361 290.24C203.162 288.433 202.922 286.536 202.673 284.53C201.945 285.448 200.818 286.766 199.312 288.213C194.784 292.545 190.127 294.771 180.073 298.345C169.073 302.258 160.286 305.322 147.67 307.469C144.089 308.078 141.746 308.347 204.299 303.186Z",
    fill: "url(#paint25_linear_328_1311)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M228.673 298.355L238.796 299.373L241.838 318.629L230.977 322.262C230.977 322.252 216.525 322.681 228.673 298.355Z",
    fill: "url(#paint26_linear_328_1311)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M111.158 322.681C124.443 340.499 130.786 349.633 140.21 353.087C153.046 357.798 167.019 354.903 184.562 348.854C190.407 346.848 196.63 344.482 203.362 341.947C211.241 338.962 209.815 338.633 219.619 334.849C228.595 331.396 233.422 330.258 235.775 325.726C237.291 322.791 237.122 319.667 236.793 317.62C235.446 311.541 234.09 305.462 232.744 299.373C231.188 297.616 228.475 295.011 224.466 293.294C222.042 292.246 219.678 291.827 217.175 291.837C217.175 291.837 217.175 291.837 217.165 291.837C216.637 291.837 216.098 291.867 215.559 291.907C208.488 292.456 200.19 296.169 186.956 299.633C186.806 299.673 186.657 299.713 186.497 299.753C172.155 303.516 159.589 307.489 159.589 307.489C159.589 307.489 137.448 279.868 131.873 272.502C131.743 272.332 131.623 272.162 131.504 272.012C127.983 267.291 122.907 260.363 116.982 251.739C115.008 250.222 112.375 248.784 109.233 248.694C99.9279 248.455 91.4007 260.304 88.8974 269.976C84.519 286.916 96.9758 303.646 111.158 322.681Z",
    fill: "url(#paint27_linear_328_1311)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M133.487 297.337C127.334 297.537 121.33 298.595 121.34 299.363C121.36 301.1 152.138 300.012 153.684 307.429C154.132 309.585 151.769 310.843 149.694 318.619C148.846 321.793 148.178 325.546 148.677 325.716C149.245 325.906 150.542 321.204 154.751 314.566C156.576 311.681 159.568 307.469 159.568 307.469C159.568 307.469 137.427 279.848 131.852 272.482C136.25 280.867 136.35 283.442 135.492 284.151C134.076 285.299 130.236 281.266 122.347 278.082C114.229 274.807 106.36 274.268 106.14 275.037C105.911 275.856 114.259 278.042 126.396 284.161C135.502 288.752 146.433 295.4 145.635 297.337C145.196 298.415 141.496 297.077 133.487 297.337Z",
    fill: "#E29F37"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M139.72 248.305C138.394 249.214 136.748 250.721 136.519 252.747C136.04 257.119 142.623 260.763 144.617 261.871C155.119 267.68 172.284 267.86 178.038 258.826C179.724 256.171 180.023 253.366 180.063 251.729C174.538 250.262 167.795 248.904 160.046 248.245C152.307 247.586 145.425 247.786 139.72 248.305Z",
    fill: "#E29F37"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M167.726 176.444C168.803 174.428 170.549 174.847 174.707 172.452C180.841 168.918 189.109 161.072 188.67 153.486C188.421 149.134 183.185 144.871 172.713 136.516C164.036 129.599 159.608 126.125 154.761 125.536C147.749 124.688 139.87 127.413 134.814 132.523C128.601 138.802 130.386 144.891 124.841 147.497C119.555 149.982 116.323 145.191 109.88 146.498C99.199 148.674 89.8639 165.564 93.923 175.446C96.925 182.753 106.111 183.432 105.891 188.423C105.682 193.075 97.6631 193.094 93.923 200.401C89.7741 208.517 94.5514 218.499 95.9177 221.364C96.8054 223.21 101.144 231.825 110.878 236.337C121.689 241.348 132.241 238.113 140.798 235.338C154.651 230.857 180.243 217.94 179.694 202.398C179.285 190.739 164.335 182.743 167.726 176.444Z",
    fill: "url(#paint28_linear_328_1311)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M176.742 220.525L176.712 226.305L176.642 241.188L176.582 255.113C176.572 257.888 174.069 259.994 171.336 259.525C163.996 258.257 151.27 255.283 148.916 249.683L153.364 215.215L176.742 220.525Z",
    fill: "url(#paint29_linear_328_1311)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M176.723 226.305C176.732 232.773 176.742 239.241 176.752 245.71C172.992 244.562 170.419 242.955 168.804 241.737C162.311 236.856 158.342 228.68 158.212 228.481L176.723 226.305Z",
    fill: "#D07975"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M191.313 224.508C189.648 228.311 188.192 231.535 184.691 233.791C184.422 233.961 184.153 234.141 183.853 234.28C183.614 234.41 183.395 234.53 183.155 234.65C178.159 237.006 172.613 235.888 168.794 235.109C167.377 234.819 166.53 234.7 165.403 234.3C157.035 231.356 153.534 222.292 152.896 220.525C152.088 218.269 152.138 217.381 152.896 201.969C153.584 188.034 153.853 182.324 158.192 179.429C158.84 179 159.448 178.77 160.685 178.271C166.709 175.856 173.8 175.836 179.385 178.441C180.223 178.81 181.041 179.289 181.799 179.769C182.258 180.058 182.696 180.367 183.105 180.687C183.923 181.266 184.611 181.845 185.11 182.274C185.18 182.344 185.23 182.384 185.27 182.424C185.319 182.464 185.359 182.504 185.399 182.544C185.529 182.663 185.639 182.753 185.718 182.833L185.838 182.953C185.878 182.983 185.908 183.003 185.928 183.033C189.049 186.107 190.535 189.222 191.303 190.879C195.173 199.194 196.629 212.36 191.313 224.508Z",
    fill: "url(#paint30_linear_328_1311)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M182.208 208.816C182.387 209.435 182.537 210.064 182.886 210.613C183.165 211.052 183.534 211.412 183.943 211.711C184.352 212.01 184.791 212.27 185.2 212.579C185.738 212.979 186.247 213.418 186.726 213.877C186.686 213.787 186.656 213.697 186.616 213.608C186.596 214.506 185.728 215.105 185 215.464C183.893 216.003 182.627 216.183 181.41 216.183C180.931 216.183 180.931 216.932 181.41 216.932C183.215 216.932 185.509 216.552 186.756 215.105C186.985 214.835 187.184 214.526 187.284 214.177C187.334 214.017 187.364 213.847 187.364 213.687C187.364 213.438 187.234 213.328 187.075 213.178C186.307 212.47 185.489 211.851 184.621 211.272C184.252 211.022 183.903 210.753 183.644 210.393C183.255 209.864 183.115 209.235 182.936 208.617C182.796 208.147 182.068 208.347 182.208 208.816Z",
    fill: "#0D0C2B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M152.916 200.99C154.591 200.162 157.164 198.774 160.017 196.658C170.07 189.211 171.606 181.755 177.45 180.747C179.784 180.347 183.394 180.896 188.471 185.967C187.384 183.532 184.89 178.86 179.944 175.446C172.533 170.345 161.852 169.607 153.793 175.446C145.296 181.605 144.079 191.917 143.83 194.003C142.164 208.107 151.36 217.97 152.547 219.188C152.676 213.128 152.796 207.059 152.916 200.99Z",
    fill: "url(#paint31_linear_328_1311)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M154.631 202.038C154.631 202.038 148.607 197.726 145.206 199.942C144.069 200.691 143.66 201.839 143.591 202.038C142.444 205.273 145.725 208.986 147.73 211.242C149.026 212.709 151.15 214.755 154.352 216.542C154.452 211.711 154.541 206.88 154.631 202.038Z",
    fill: "url(#paint32_linear_328_1311)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M193.018 196.448C191.772 195.33 189.997 194.851 188.371 195.301C187.104 195.65 185.947 196.568 185.309 197.716C185.07 198.135 185.718 198.515 185.957 198.096C186.496 197.147 187.433 196.369 188.481 196.049C189.867 195.63 191.423 196.009 192.49 196.978C192.849 197.297 193.377 196.778 193.018 196.448Z",
    fill: "#0D0C2B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M174.028 196.448C172.782 195.33 171.006 194.851 169.381 195.301C168.114 195.65 166.957 196.568 166.319 197.716C166.079 198.135 166.728 198.515 166.967 198.096C167.506 197.147 168.443 196.369 169.49 196.049C170.877 195.63 172.432 196.009 173.5 196.978C173.849 197.297 174.377 196.778 174.028 196.448Z",
    fill: "#0D0C2B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M187.562 202.508C187.562 204.145 188.231 205.482 189.049 205.482C189.866 205.482 190.535 204.155 190.535 202.508C190.535 200.87 189.866 199.533 189.049 199.533C188.231 199.533 187.562 200.87 187.562 202.508Z",
    fill: "#0D0C2B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M169.162 202.508C169.162 204.145 169.96 205.482 170.947 205.482C171.935 205.482 172.733 204.155 172.733 202.508C172.733 200.87 171.935 199.533 170.947 199.533C169.96 199.543 169.162 200.87 169.162 202.508Z",
    fill: "#0D0C2B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M184.49 224.129C181.02 224.748 177.599 223.32 175.355 220.665C175.046 220.296 174.517 220.825 174.826 221.194C177.25 224.069 180.96 225.516 184.69 224.857C185.169 224.767 184.969 224.049 184.49 224.129Z",
    fill: "#C93E60"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M147.689 203.466C149.056 203.745 150.192 204.544 150.811 205.812C151.469 207.159 151.419 208.736 150.99 210.134C150.851 210.593 151.569 210.793 151.708 210.334C152.197 208.726 152.197 206.96 151.459 205.432C150.771 204.005 149.425 203.057 147.889 202.737C147.42 202.647 147.22 203.366 147.689 203.466Z",
    fill: "#0D0C2B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M169.432 261.561C174.957 261.362 179.485 257.069 179.894 251.549C180.013 249.982 180.093 247.437 180.063 246.658C179.993 244.472 179.904 241.797 179.046 241.587C178.398 241.428 177.7 242.795 177.021 243.614C173.291 248.096 160.974 246.778 151.709 242.595C147.829 240.849 145.266 238.882 143.65 240.12C142.474 241.028 143.152 243.843 142.593 246.648C141.686 251.24 144.907 262.44 169.432 261.561Z",
    fill: "url(#paint33_linear_328_1311)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M243.245 338.892C241.769 345.989 240.283 353.087 238.807 360.184C238.527 375.646 239.425 393.434 242.656 412.879C244.033 421.154 245.698 428.95 247.533 436.227C251.074 415.774 252.869 389.621 247.922 360.174C246.646 352.627 245.05 345.53 243.245 338.892Z",
    fill: "url(#paint34_linear_328_1311)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M155.768 372.342C155.768 373.46 156.675 374.368 157.792 374.368C158.909 374.368 159.817 373.46 159.817 372.342C159.817 371.224 158.909 370.316 157.792 370.316C156.675 370.316 155.768 371.224 155.768 372.342Z",
    fill: "#060506"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M203.311 579.659C205.196 597.666 207.081 615.674 208.965 633.682C216.884 634.38 224.793 635.079 232.712 635.778C231.884 615.734 231.057 595.69 230.229 575.646C221.253 576.984 212.277 578.321 203.311 579.659Z",
    fill: "url(#paint35_linear_328_1311)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M205.616 623.38C208.329 622.272 211.48 621.603 216.746 621.094C222.122 620.565 228.325 621.394 231.198 621.973C232.744 628.341 232.803 634.021 234.808 639.521C238.738 650.292 241.47 654.294 243.814 662.979C245.48 669.138 246.297 675.227 246.457 681.176C240.692 683.332 231.198 686.157 219.24 686.377C209.585 686.556 201.736 684.979 196.44 683.502C196.54 663.967 204.1 646.858 205.357 636.836C206.853 624.897 204.948 624.109 205.616 623.38Z",
    fill: "#2895A9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M240.233 678.93C239.984 679 239.734 678.98 239.505 678.87C237.67 677.942 229.611 674.288 222.889 677.802C221.872 678.331 220.605 679.18 219.379 680.547C219.219 680.727 219.02 680.847 218.78 680.887C214.183 681.635 208.109 681.905 202.165 679.579C200.439 678.9 198.165 678.132 196.51 677.383C195.862 677.093 195.443 677.642 195.074 678.261C194.266 679.609 194.645 685.379 194.565 687.205C194.545 687.714 194.854 688.174 195.333 688.303C200.798 689.771 209.106 694.682 218.302 694.512C229.771 694.302 241.929 691.697 247.873 689.701C248.322 689.551 248.601 689.102 248.561 688.623C248.431 687.026 247.943 680.038 247.743 678.251C247.673 677.603 247.065 677.183 246.447 677.343C244.502 677.872 241.998 678.411 240.233 678.93Z",
    fill: "#2C416C"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1437 462.55H162.969C163.607 465.584 164.235 468.619 164.884 471.653C174.468 517.271 184.072 562.879 193.657 608.507C199.112 610.394 207.649 612.62 218.281 612.56C228.474 612.5 236.692 610.354 242.038 608.507C237.759 577.074 233.461 545.66 229.172 514.227C225.422 486.746 221.672 459.266 217.922 431.785C217.713 430.228 217.503 428.661 217.284 427.103C216.057 418.12 208.886 411.082 199.81 409.924L95.3591 396.678C91.7287 401.14 83.2913 412.689 81.2667 429.679C81.1769 430.487 81.0871 431.306 81.0173 432.154C79.9203 446.109 83.75 457.03 86.1437 462.55Z",
    fill: "#2A3964"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1437 462.55H162.969C163.607 465.584 164.235 468.619 164.884 471.653L161.433 445.121C161.433 445.121 158.491 448.215 153.235 451.43C149.774 453.556 142.035 458.157 131.213 458.497C128.78 458.577 117.141 458.716 106.629 451.4C98.6104 445.81 94.8305 438.373 93.3145 439.241C92.2673 439.83 93.2946 443.763 94.3418 446.339C97.3139 453.656 103.328 457.039 102.51 458.387C102.041 459.166 99.7274 458.567 99.4581 458.497C92.8657 456.87 86.2633 441.438 81.2667 429.669C81.1769 430.477 81.0871 431.296 81.0173 432.144C79.9203 446.109 83.75 457.029 86.1437 462.55Z",
    fill: "url(#paint36_linear_328_1311)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M150.193 462.55H162.899C163.538 460.044 163.897 458.118 163.887 457.109C163.887 457.109 162.85 442.286 172.983 434.171C183.106 426.065 166.42 432.783 159.578 445.64C157.524 449.483 153.923 455.702 150.193 462.55Z",
    fill: "url(#paint37_linear_328_1311)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M212.477 452.408C212.477 458.866 220.814 492.905 229.322 514.217C225.612 486.736 221.911 459.255 218.201 431.775C215.808 437.824 212.477 447.217 212.477 452.408Z",
    fill: "url(#paint38_linear_328_1311)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M177.699 435.538C171.835 441.847 169.77 447.527 168.933 451.4C166.12 464.396 172.164 480.058 172.164 480.058C172.164 480.058 182.417 453.117 177.699 435.538Z",
    fill: "url(#paint39_linear_328_1311)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M184.123 445.321C182.866 452.747 181.111 463.178 179.056 475.726C176.094 493.863 175.954 495.341 176.014 498.026C176.224 506.56 186.137 535.528 186.137 535.528C187.713 525.586 188.88 514.426 189.179 502.208C189.728 480.118 187.284 460.843 184.123 445.321Z",
    fill: "url(#paint40_linear_328_1311)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M217.155 291.827C216.626 291.827 216.087 291.857 215.549 291.897C216.436 291.927 217.045 291.847 217.155 291.827Z",
    fill: "url(#paint41_linear_328_1311)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M184.562 348.844C190.406 346.838 196.629 344.472 203.361 341.937C211.24 338.952 209.814 338.623 219.618 334.839C228.594 331.386 233.421 330.248 235.775 325.716C237.291 322.781 237.121 319.657 236.792 317.61C235.446 311.531 234.089 305.452 232.743 299.363C231.187 297.606 228.474 295.001 224.465 293.284C222.042 292.236 219.678 291.817 217.174 291.827C217.174 291.827 230.718 298.355 229.701 303.426C228.684 308.497 217.553 312.549 212.487 317.62C207.421 322.691 233.75 310.523 232.743 312.549C231.726 314.576 214.512 332.823 196.29 341.947C190.246 344.951 186.616 347.177 184.562 348.844Z",
    fill: "#E29F37"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_1311",
    x1: 294.946,
    y1: 658.912,
    x2: 68.1557,
    y2: 323.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8e-7,
    stopColor: "#D26F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_328_1311",
    x1: -11.7452,
    y1: 312.245,
    x2: 128.724,
    y2: 119.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8e-7,
    stopColor: "#D26F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_328_1311",
    x1: 282.747,
    y1: 662.073,
    x2: 242.421,
    y2: 602.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8e-7,
    stopColor: "#D26F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_328_1311",
    x1: 94.8252,
    y1: 122.406,
    x2: 78.3841,
    y2: 67.4524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8e-7,
    stopColor: "#D26F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_328_1311",
    x1: 446.408,
    y1: 448.746,
    x2: 446.408,
    y2: 16.0642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8e-7,
    stopColor: "#D26F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_328_1311",
    x1: 579.769,
    y1: 523.125,
    x2: 579.769,
    y2: 460.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8e-7,
    stopColor: "#D26F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_328_1311",
    x1: 624.842,
    y1: 460.734,
    x2: 624.842,
    y2: 322.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8e-7,
    stopColor: "#D26F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_328_1311",
    x1: 514.373,
    y1: 596.739,
    x2: 514.373,
    y2: 529.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8e-7,
    stopColor: "#D26F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_328_1311",
    x1: 245.196,
    y1: -1.01464,
    x2: 234.996,
    y2: 65.2985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.8e-7,
    stopColor: "#D26F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_328_1311",
    x1: 147.085,
    y1: 536.626,
    x2: 167.285,
    y2: 523.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#F1CE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_328_1311",
    x1: 636.009,
    y1: 295.901,
    x2: 617.72,
    y2: 295.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#F1CE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_328_1311",
    x1: 49.7879,
    y1: 180.19,
    x2: 10.1635,
    y2: 180.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#F1CE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_328_1311",
    x1: 632.129,
    y1: 188.465,
    x2: 613.742,
    y2: 188.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#F1CE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_328_1311",
    x1: 16.1207,
    y1: 359.801,
    x2: 1.03387,
    y2: 359.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#F1CE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_328_1311",
    x1: 537.836,
    y1: 507.779,
    x2: 355.07,
    y2: 507.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#F1CE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_328_1311",
    x1: 272.271,
    y1: 294.416,
    x2: 247.919,
    y2: 294.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00446955,
    stopColor: "#F9DAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA58F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_328_1311",
    x1: 233.945,
    y1: 418.872,
    x2: 217.341,
    y2: 519.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECCBBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_328_1311",
    x1: 153.389,
    y1: 388.051,
    x2: 136.525,
    y2: 388.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#17163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_328_1311",
    x1: 171.172,
    y1: 396.064,
    x2: 162.377,
    y2: 390.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17163E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_328_1311",
    x1: 174.099,
    y1: 483.607,
    x2: 172.028,
    y2: 479.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17163E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_328_1311",
    x1: 164.521,
    y1: 421.23,
    x2: 206.434,
    y2: 388.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17163E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_328_1311",
    x1: 198.487,
    y1: 294.406,
    x2: 195.561,
    y2: 284.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17163E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_328_1311",
    x1: 242.856,
    y1: 306.974,
    x2: 101.478,
    y2: 306.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D85168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_328_1311",
    x1: 267.048,
    y1: 306.968,
    x2: 238.804,
    y2: 306.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA58F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_328_1311",
    x1: 295.721,
    y1: 307.519,
    x2: 264.121,
    y2: 307.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#F9DAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA58F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_328_1311",
    x1: 176.885,
    y1: 314.18,
    x2: 174.754,
    y2: 298.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AEBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBACB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_328_1311",
    x1: 223.814,
    y1: 310.303,
    x2: 241.842,
    y2: 310.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AEBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBACB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_328_1311",
    x1: 161.7,
    y1: 299.145,
    x2: 146.163,
    y2: 337.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-8,
    stopColor: "#F1CE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1CE68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_328_1311",
    x1: 130.386,
    y1: 163.27,
    x2: 113.931,
    y2: 130.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#2A3964"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_328_1311",
    x1: 187.588,
    y1: 237.41,
    x2: 230.703,
    y2: 237.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECCBBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_328_1311",
    x1: 140.592,
    y1: 212.361,
    x2: 180.261,
    y2: 204.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECCBBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_328_1311",
    x1: 160.294,
    y1: 183.806,
    x2: 153.702,
    y2: 170.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#2A3964"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_328_1311",
    x1: 148.185,
    y1: 206.432,
    x2: 162.865,
    y2: 212.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8257,
    stopColor: "#ECCBBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_328_1311",
    x1: 180.074,
    y1: 250.678,
    x2: 142.466,
    y2: 250.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-8,
    stopColor: "#F1CE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1CE68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_328_1311",
    x1: 244.858,
    y1: 544.99,
    x2: 244.858,
    y2: 536.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17163E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_328_1311",
    x1: 215.432,
    y1: 586.393,
    x2: 238.535,
    y2: 687.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECCBBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_328_1311",
    x1: 80.8275,
    y1: 450.658,
    x2: 164.884,
    y2: 450.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#17163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_328_1311",
    x1: 150.196,
    y1: 446.593,
    x2: 176.162,
    y2: 446.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#17163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_328_1311",
    x1: 337.061,
    y1: 338.027,
    x2: 252.686,
    y2: 438.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#17163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_328_1311",
    x1: 251.143,
    y1: 366.968,
    x2: 194.374,
    y2: 434.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#17163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_328_1311",
    x1: 322.328,
    y1: 326.991,
    x2: 220.164,
    y2: 448.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    stopColor: "#17163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_328_1311",
    x1: 216.367,
    y1: 291.992,
    x2: 216.35,
    y2: 291.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AEBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBACB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.76677292be2aef6329a507746c084be6.svg";
export { ForwardRef as ReactComponent };